import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../createRequestHook"
import { ResolvedFleetEntry } from "../../fleet"
import { toResolution } from "./utils"

export const manualResolveEntries = createRequest<
  Readonly<{ entries: ReadonlyArray<ResolvedFleetEntry>; vehicleSetId: string }>,
  void
>(async (input, getToken) => {
  const api = platform(getToken)

  const resolutions = input.entries.map(toResolution)

  if (resolutions.length === 0) return
  api.vehicles.resolveVehicleSetEntries({ id: input.vehicleSetId, requestBody: { resolutions } })
})

export const useManualResolveEntries = createRequestHook(manualResolveEntries)
